/**
 * La page est-elle affichée en mode SOMBRE ? (03/10/2026)
 *
 * Tous les fronts de la suite posent `color-scheme` sur `<html>` quand ils
 * appliquent une palette (`applyColorScheme` de la charte, ou le store de
 * SEmplyApp qui fait de même). C'est donc là qu'on lit le mode, et pas dans
 * un contrôleur : SEmplyApp n'utilise pas celui de la charte.
 *
 * Usage premier : servir la bannière `banner-dark.svg` en sombre. Son wordmark
 * a une encre presque noire, qui disparaît sur un bandeau sombre ; on ne
 * l'inverse pas en CSS — un filtre sur un logo abîme la marque — on sert une
 * seconde image.
 */
export function estSombre() {
  if (typeof document === 'undefined') return false;
  return document.documentElement.style.colorScheme === 'dark';
}

/** Prévient `rappel` à chaque changement de mode. Rend la fonction de désabonnement. */
export function surChangementSombre(rappel) {
  if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') return () => {};
  let dernier = estSombre();
  const observateur = new MutationObserver(() => {
    const actuel = estSombre();
    if (actuel !== dernier) {
      dernier = actuel;
      rappel(actuel);
    }
  });
  observateur.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
  return () => observateur.disconnect();
}

/** Bannière de la suite selon le mode : `banner-dark.svg` en sombre, `banner.svg` sinon. */
export const BANNIERE = { clair: '/logo/banner.svg', sombre: '/logo/banner-dark.svg' };
